














































import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { saveinfo, getUser } from '../api';
import qs from 'qs';
import { Toast } from 'vant';

@Component
export default class Home extends Vue {
  showread: boolean = false;
  phone: string = '';
  intonowx: boolean = false;
  indata: any = {};
  qrCode: string = '';
  async mounted() {
    this.showread = true;
    const unionId = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      this.intonowx = true;
      return false;
    } else if (!unionId && isWeiXin()) {
      this.WechatLogin();
      return false;
    }
    getUser(unionId).then((res: any) => {
      if (res.code === 200) {
        const indata = this.$route.query;
        this.$router.push('showcreaten?id=' + indata.id);
      } else {
        this.showread = true;
      }
    });
  }
  subPhone() {
    const unionId = window.localStorage.getItem('unionid');
    if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    }
    const data = {
      unionid: unionId,
      phone: this.phone,
    };
    saveinfo(data).then((res: any) => {
      if (res.code === 200) {
        const indata = this.$route.query;
        this.$router.push('showcreaten?id=' + indata.id);
      } else {
        Toast(res.msg);
        return false;
      }
    });
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
